import { UniteTypeBank } from '~/generated/payoutBackend/model';

export const banks = Object.values(UniteTypeBank)
    .filter((bank) => bank !== UniteTypeBank.BANK_UNSPECIFIED)
    .map((value) => ({
        value,
        label: value.replace('BANK_', '').replaceAll('_', ' '),
    }));
